import { render, staticRenderFns } from "./AddProductToPortfolioModalContent.vue?vue&type=template&id=2140857a&scoped=true&"
import script from "./AddProductToPortfolioModalContent.vue?vue&type=script&lang=js&"
export * from "./AddProductToPortfolioModalContent.vue?vue&type=script&lang=js&"
import style0 from "./AddProductToPortfolioModalContent.vue?vue&type=style&index=0&id=2140857a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2140857a",
  null
  
)

export default component.exports